export const Footer = (props) => {
  
  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; Made by Wal${' '}
          </p>
        </div>
      </div>
    </div>
  )
}
